import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend'; // Thêm HttpBackend
import { getConfigFromWindowBrowser } from '@/utilities';
import { ENV } from '@/utilities/EWindow';

const REMOTE_URL = getConfigFromWindowBrowser(ENV.REMOTE_URL) ?? ''

i18n
    .use(HttpBackend) // Sử dụng HttpBackend để tải file JSON
    .use(initReactI18next)
    .init({
        lng: 'vi', // Ngôn ngữ mặc định
        fallbackLng: 'vi', // Ngôn ngữ dự phòng
        backend: {
            loadPath: `${REMOTE_URL}/locales/{{lng}}.json` // Đường dẫn tới các file JSON
        },
        interpolation: {
            //escapeValue: true, // Tránh lỗi XSS (Cross-Site Scripting)
            escapeValue: false // React đã tự động escape, không cần i18next escape lần 2
        }
    });

export default i18n;
